export const communityTranslations = {
  community_hero: {
    badge: "منصة مجتمع Quality Nexus",
    title: "حيث يتواصل مختبرو البرمجيات ويتعلمون وينمون",
    description: "ملفات مهنية ومنشورات ونقاشات وإرشاد ومجموعات دراسة ومسارات تعلم وأدوات وفعاليات ووظائف في ضمان الجودة — كل ما تحتاجه لمسيرتك في منصة واحدة.",
    createProfile: "أنشئ ملفك الشخصي",
    exploreCommunity: "استكشف المنصة",
  },
  features: {
    title: "كل ما ستجده داخل المنصة",
    description: "مزايا متاحة اليوم في المجتمع، صُممت خصيصًا لتناسب طريقة عمل محترفي الاختبار وتعلّمهم.",
    modules: {
      profiles: { title: "ملفات مهنية", description: "المهارات والخبرات والشهادات ومعرض الأعمال في ملف واحد مخصص لضمان الجودة." },
      feed: { title: "منشورات اجتماعية", description: "انشر تحديثاتك وشارك إنجازاتك وتابع ما يعمل عليه المختبرون." },
      discussions: { title: "النقاشات", description: "أسئلة وأجوبة مترابطة يجيب فيها المجتمع عن مشكلات الاختبار الحقيقية." },
      connections: { title: "التواصل والمراسلة", description: "تابع المختبرين ووسّع شبكتك وتحدث معهم مباشرة." },
      mentorship: { title: "الإرشاد", description: "اعثر على مرشد أو كن مرشدًا واستفد من موارد إرشادية منتقاة." },
      groups: { title: "مجموعات الدراسة", description: "تعلّم مع الآخرين في مجموعات صغيرة تركز على أداة أو مهارة أو شهادة." },
      roadmaps: { title: "مسارات التعلّم", description: "مسارات خطوة بخطوة للأتمتة والأداء والأمان وغيرها." },
      tools: { title: "دليل الأدوات", description: "تصفح أدوات الاختبار وقارن بينها بالاستفادة من خبرات المجتمع." },
      events: { title: "الفعاليات واللقاءات", description: "أنشئ واكتشف وانضم إلى الندوات وورش العمل ولقاءات المجتمع." },
      jobs: { title: "وظائف ضمان الجودة", description: "فرص عمل في الاختبار تشاركها الشركات وأعضاء المجتمع." },
    },
  },
  deepDive: {
    title: "كيف يستفيد الأعضاء من المجتمع",
    description: "من بناء ملفك المهني إلى الحصول على فرصتك التالية، تدعمك المنصة في كل مرحلة من مسيرتك في ضمان الجودة.",
    tabs: {
      profiles: {
        label: "الملفات", title: "اعرض خبرتك في الاختبار",
        description: "أنشئ ملفًا متكاملًا بمهاراتك وخبراتك وشهاداتك وأعمالك، واجعل الزملاء وفرق التوظيف يكتشفونك في دليل المختبرين.",
        points: ["أقسام للمهارات والخبرات والشهادات مخصصة لضمان الجودة", "صفحة ملف عامة تعرض أعمالك ونشاطك", "ظهورك في دليل مختبري المجتمع"],
        cta: "أنشئ ملفك",
      },
      networking: {
        label: "المنشورات والشبكة", title: "ابقَ على تواصل مع مجتمع الاختبار",
        description: "تبقيك المنشورات والنقاشات المترابطة والتواصل والمراسلة المباشرة قريبًا ممن يعملون على التحديات نفسها.",
        points: ["انشر تحديثاتك وتفاعل مع مشاركات المختبرين", "اطرح أسئلتك في النقاشات واحصل على إجابات", "أرسل طلبات التواصل وتحدث عبر الرسائل المباشرة"],
        cta: "استكشف المنشورات",
      },
      learning: {
        label: "التعلّم", title: "تطور مع الإرشاد والمجموعات والمسارات",
        description: "يمنحك الإرشاد المنظم ومجموعات الدراسة ومسارات التعلم طريقًا واضحًا من مستواك الحالي إلى هدفك في ضمان الجودة.",
        points: ["تواصل مع المرشدين واستفد من موارد الإرشاد", "انضم إلى مجموعات دراسة أو أنشئ مجموعة حول مهارة أو شهادة", "اتبع مسارات التعلم وتابع تقدمك"],
        cta: "تصفح المسارات",
      },
      opportunities: {
        label: "الفرص", title: "الأدوات والفعاليات والوظائف في مكان واحد",
        description: "اكتشف الأدوات التي يستخدمها المختبرون وانضم إلى فعاليات المجتمع واعثر على فرصتك التالية داخل المنصة.",
        points: ["دليل يتضمن تفاصيل كل أداة اختبار", "فعاليات ولقاءات يمكنك حضورها أو استضافتها", "وظائف ضمان الجودة من أعضاء المجتمع"],
        cta: "استكشف الفرص",
      },
    },
  },
  stats: { members: "أعضاء المجتمع", discussions: "نقاشات بدأت", mentors: "مرشدون نشطون", jobs: "وظائف ضمان جودة" },
  joinCTA: {
    title: "هل أنت مستعد للانضمام إلى مجتمع Quality Nexus؟",
    description: "أنشئ ملفك وشارك في النقاشات واعثر على مرشد واتخذ الخطوة التالية في مسيرتك في الاختبار.",
    action: "أنشئ ملفك",
    mentorAction: "كن مرشدًا",
  },
};
